<template>
  <div>
    <a-row>
      <a-col :span="24">
        <div class="top">
          <span class="a-span">角色名称：</span>
          <a-input
            class="a-input"
            v-model="roleName"
            placeholder="请输入角色名称"
          ></a-input>
          <span class="b-span">角色描述：</span>
          <a-textarea
            v-model="roleDesc"
            class="a-textarea"
            placeholder="请输入角色描述"
            :rows="4"
          />
        </div>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <div class="top" style="height: auto;">
          <a-tree
            class="tree"
            v-model="checkedKeys"
            checkable
            :expanded-keys="expandedKeys"
            :auto-expand-parent="autoExpandParent"
            :selected-keys="selectedKeys"
            :tree-data="ywArr"
            @expand="onExpand"
            @select="onSelect"
            :replaceFields="{ children: 'children' }"
          />
        </div>
      </a-col>
    </a-row>
    <div class="s-button">
      <a-button @click="save">保存</a-button>
      <a-button @click="goBack">返回</a-button>
    </div>
  </div>
</template>
<script>
import {
  storePermissionsListAdd,
  storePermissionsListCreate,
  storePermissionsListDetails,
  storePermissionsListEdit,
  getRoleMenuByRoleId
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";
const ywArr = [];
const xmArr = [];
const treeData = [
  {
    title: "0-0-0-1",
    key: "0-0",
    children: [
      {
        title: "0-0-0",
        key: "0-0-0",
      },
      {
        title: "0-0-1",
        key: "0-0-1",
        children: [
          { title: "0-0-1-0", key: "0-0-1-0" },
          { title: "0-0-1-1", key: "0-0-1-1" },
          { title: "0-0-1-2", key: "0-0-1-2" },
        ],
      },
      {
        title: "0-0-2",
        key: "0-0-2",
      },
    ],
  },
  {
    title: "0-1",
    key: "0-1",
    children: [
      { title: "0-1-0-0", key: "0-1-0-0" },
      { title: "0-1-0-1", key: "0-1-0-1" },
      { title: "0-1-0-2", key: "0-1-0-2" },
    ],
  },
  {
    title: "0-2",
    key: "",
  },
  {
    title: "0-3",
    key: "",
  },
  {
    title: "0-4",
    key: "",
  },
  {
    title: "0-5",
    key: "",
  },
  {
    title: "0-6",
    key: "",
  },
  {
    title: "0-7",
    key: "",
  },
  {
    title: "0-8",
    key: "",
  },
  {
    title: "0-9",
    key: "",
  },
  {
    title: "0-10",
    key: "",
  },
];
export default {
  data() {
    return {
      treeData,
      expandedKeys: ["0-0-0", "0-0-1"],
      autoExpandParent: true,
      checkedKeys: [],//开始赋值默认值
      selectedKeys: [],
      xmArr,
      ywArr,
      menuIdList: [],
      roleName: "",
      roleDesc: "",
    };
  },
  watch: {
    checkedKeys(val) {
      console.log("onCheck", val);
    },
  },
  mounted() {
    this.getStorePermissionsListAdd();
    this.getStorePermissionsListDetails();
    this.getRoleMenuByRoleId();
  },
  methods: {
    setName(datas){ //遍历树  获取id数组
      for(var i in datas){
        if(datas[i].select){
          this.checkedKeys.push(datas[i].objId)  // 遍历项目满足条件后的操作
        }
        if(datas[i].children){  //存在子节点就递归
          this.setName(datas[i].children);
        }
      }
    },
    onExpand(expandedKeys) {
      console.log("onExpand", expandedKeys);
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys) {
      console.log("onCheck", checkedKeys);
      this.checkedKeys = checkedKeys;
      this.menuIdList = checkedKeys;
    },
    onSelect(selectedKeys, info) {
      console.log("onSelect", info);
      this.selectedKeys = selectedKeys;
    },
    // 明细
    getStorePermissionsListDetails() {
      let roleId = this.$route.query.id;
      storePermissionsListDetails(roleId).then((res) => {
        this.roleName = res.data.roleName;
        this.roleDesc = res.data.roleDesc;
      });
    },
    getStorePermissionsListAdd() {
      storePermissionsListAdd().then((res) => {
        this.setName(res.data)
        res.data.map((item) => {
          this.ywArr.push({
            title: item.name,
            key: item.objId,
            children: this.loop(item.children),
          });
        });
      });
    },
    getRoleMenuByRoleId() {
      let roleId = this.$route.query.id;
      getRoleMenuByRoleId(roleId).then(res => {
        this.checkedKeys = res.data;
      });
    },
    loop(item) {
      if (item !== null) {
        console.log(item, "item ==> 不为null");
        let arr = [];
        item.forEach((item) => {
          arr.push({
            title: item.name,
            key: item.objId,
          });
        });
        return arr;
      }
    },
    save() {
      let id = this.$route.query.id;
      let obj = {
        id: id,
        isShop: 1,
        roleName: this.roleName,
        roleDesc: this.roleDesc,
        menuIdList: this.checkedKeys,
      };
      if (this.roleName.trim() !== "") {
        storePermissionsListEdit(obj).then((res) => {
          message.success(res.info);
          this.$router.push("/home/partManagementTwo/partManagementHomeTwo");
          location.reload();
        });
      } else {
        message.warning("角色描述不可为空");
      }
    },
    goBack() {
      this.$router.push("/home/partManagementTwo/partManagementHomeTwo");
      location.reload();
    },
  },
};
</script>

<style scoped>
.s-button {
  margin-left: 20px;
}
.tree {
  position: relative;
  left: 160px;
}
.a-span {
  position: relative;
  left: 80px;
  top: 25px;
}
.b-span {
  position: relative;
  top: 75px;
  left: 80px;
}
.a-input {
  position: relative;
  left: 160px;
  display: block;
  width: 350px;
}
.a-textarea {
  position: relative;
  left: 160px;
  top: 50px;
  display: block;
  width: 450px;
}
.top {
  margin: 15px;
  height: 400px;
  background-color: rgb(255, 255, 255);
}
</style>



// WEBPACK FOOTER //
// src/views/right/partManagementTwo/EditpartManagementTwo/EditpartManagementTwo.vue